import styled from '@emotion/styled'
import { withClass } from '@news-mono/web-common'
import { fonts } from '../../__styling'
import { colors } from '../../__styling/settings/colors'
import { calcRem } from '../../__styling/style-functions/calc-rem'
import { visuallyhidden } from '../../__styling/style-mixins'
import { themedValue } from '../../__styling/themed-value'

interface StyledActiveProps {
    active?: boolean
    primary?: boolean
}

const StyledToggleSwitchClassName = 'StyledToggleSwitch'

export const StyledToggleCheckbox = styled('input')(visuallyhidden)
export const StyledToggleLabel = styled('label')(visuallyhidden)

export const StyledToggle = styled('div')()

export const StyledLabelledToggle = styled('button')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr',
    gridTemplateAreas: '. .',
    background: colors.thewest.greyErmine,
    border: `1px solid ${colors.thewest.greyDolphin}`,
    borderRadius: 2,
    cursor: 'pointer',
    padding: 5,
    fontFamily: fonts.designSystem.sansSerif,
}))

export const StyledToggleSwitch = withClass(StyledToggleSwitchClassName)(
    styled('span')<StyledActiveProps>(({ theme, active, primary }) => {
        const shouldHaveBackground =
            (active && primary) || (!active && !primary)

        const activeBackground = themedValue(theme, {
            thewest: primary
                ? colors.thewest.westblue
                : colors.thewest.greyHippo,
            perthnow: primary
                ? colors.perthnow.pinkThulite
                : colors.thewest.greyHippo,
            sevennews: primary
                ? colors.sevennews.red
                : colors.thewest.greyHippo,
            fallback: 'transparent',
        })

        return {
            display: 'inline-block',
            backgroundColor: shouldHaveBackground
                ? activeBackground
                : 'transparent',
            color: shouldHaveBackground
                ? colors.white
                : colors.thewest.greyHippo,
            padding: calcRem(3, 6),
            textTransform: 'uppercase',
            borderRadius: 2,
            fontSize: calcRem(12),
        }
    }),
)
